export const iconNameFromComponentName = componentName => {
  let name = componentName.replace("Icon", "")
  // split by capital letters
  const split = name.split(/(?=[A-Z])/)
  // join with hyphen
  name = split.join("-").toLowerCase()
  return name
}

export const componentNameFromIconName = iconName => {
  // split by hyphen
  const split = iconName.split("-")
  // capitalize each element
  const capitalized = split.map(
    word => word.charAt(0).toUpperCase() + word.slice(1)
  )
  // join with capital letters
  return `${capitalized.join("")}Icon`
}
